import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CreateExpedienteParteRequest } from '@models/expedienteParte/createExpedienteParteRequest.model';
import { ExpedienteParteDto } from '@models/expedienteParte/expedienteParteDto.model';
import { PersonaDto } from '@models/persona/personaDto.model';
import { SharedModule } from '@modules/shared.module';
import { ExpedienteParteService } from '@services/expedienteParte/expedienteParte.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoParteService } from '@services/tipoParte/tipoParte.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { DialogCreatePersonaSimpleComponent } from '@views/personas/dialog-create-persona-simple/dialog-create-persona-simple.component';
import { DialogViewBasicPersonaComponent } from '@views/personas/dialog-view-basic-persona/dialog-view-basic-persona.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ButtonActionComponent } from 'src/app/component/button-action/button-action.component';
import { ButtonExportFileComponent } from 'src/app/component/button-export-file/button-export-file.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { BuscarPersonaComponent } from '@views/busquedas/buscar-persona/buscar-persona.component';
import { ButtonAddComponent } from 'src/app/component/button-add/button-add.component';
import { DialogFormPersonaComponent } from '@views/personas/dialog-form-persona/dialog-form-persona.component';
import { DialogParams } from '@interfaces/dialogParam.interface.model';


@Component({
  standalone: true,
  imports: [AppRolesDirective, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule,      CommonModule, FormsModule, MatSortModule,  MatTooltipModule, MatPaginatorModule, MatRippleModule,BuscarPersonaComponent,ButtonAddComponent,ButtonNewComponent],
  selector: 'app-form-expediente-partes',
  templateUrl: './form-expediente-partes.component.html',
  styleUrls: ['./form-expediente-partes.component.css'],
})
export class FormExpedientePartesComponent {
  accionesDialog = AccionesDialog;
  formBuilder: FormBuilder = new FormBuilder;
  expedienteParteForm: any;
  tiposParte!: BaseDto[];
  expedientePartes!: ExpedienteParteDto[];
  idExpediente: any;
  personaDto: any;
  dataSource = new MatTableDataSource<ExpedienteParteDto>();
  displayedColumnsExpedienteParte: string[] = ['tipoParte', 'persona', 'descripcion', 'accion'];
  data: boolean = false;
  constructor(
    public dialog: MatDialog,
    private tipoParteService: TipoParteService,
    private expedienteParteService: ExpedienteParteService,
    private spinner: NgxSpinnerService,
    private snackBar: SnackBarService,
    private activatedRoute: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
  ) {

    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumnsExpedienteParte = result.matches ?
        ['tipoParte', 'persona', 'accion'] :
        ['tipoParte', 'persona', 'descripcion', 'accion'];
    });


  }

  ngOnInit() {
    let idExpediente = this.activatedRoute.snapshot.params['id']
    this.idExpediente = idExpediente
    this.getExpedienteParteByIdExpediente(idExpediente)
    this.getAllTiposParte()

    this.expedienteParteForm = this.formBuilder.group({
      Descripcion: [''],
      TipoParte: ["", Validators.compose([Validators.required])],
    });
  }

  getExpedienteParteByIdExpediente(idExpediente: any) {
    this.spinner.show("spExpedienteParte")
    this.expedienteParteService.getAllByIdExpediente(idExpediente)
      .subscribe(
        data => {
          this.spinner.hide("spExpedienteParte")
          this.expedientePartes = data
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide("spExpedienteParte")
          this.snackBar.showError(error, "Error");
        })
  }

  verInfoPersona(personaDto: PersonaDto) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.autoFocus = false
    dialogConfig.data = personaDto
    dialogConfig.width = "30%"

    const dialogRef = this.dialog.open(DialogViewBasicPersonaComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  onNuevaPersona(): void {
    const dialogRef = this.dialog.open(DialogCreatePersonaSimpleComponent, {
    });

    dialogRef.afterClosed().subscribe(result => {
      let idPersona = result;
    });
  }
  seleccionPersona(event: any) {
    this.personaDto = event
  }
  getAllTiposParte() {
    this.spinner.show("spTipoParte")
    this.tipoParteService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTipoParte")
          this.tiposParte = data
        },
        error => {
          this.spinner.hide("spTipoParte")
          this.snackBar.showError(error, "Error");
        })
  }

  onSubmit() {
    if (this.expedienteParteForm.invalid) {
      return;
    }
    const createExpedienteParteRequest: CreateExpedienteParteRequest = this.setCreateExpedienteParteRequest();
    this.spinner.show("spExpedienteParte")
    this.expedienteParteService.create(createExpedienteParteRequest)
      .subscribe(
        data => {
          this.spinner.hide("spExpedienteParte")
          this.snackBar.showSuccess("Se agrego el registro correctamente.", "");
          this.getExpedienteParteByIdExpediente(this.idExpediente)
        },
        error => {
          this.spinner.hide("spExpedienteParte")
          this.snackBar.showError(error, "Error");
        })
  }

  setCreateExpedienteParteRequest(): CreateExpedienteParteRequest {

    const createExpedienteParteRequest = new CreateExpedienteParteRequest();

    createExpedienteParteRequest.idTipoParte = this.expedienteParteForm.controls['TipoParte'].value;
    createExpedienteParteRequest.descripcion = this.expedienteParteForm.controls['Descripcion'].value;
    createExpedienteParteRequest.idExpediente = this.idExpediente
    createExpedienteParteRequest.idPersona = this.personaDto.id

    return createExpedienteParteRequest
  }

  openDialog(action: any, obj: { action?: any; }) {
    obj.action = action;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "50%",
      dialogConfig.autoFocus = false;
    dialogConfig.data = obj

    const dialogRef = this.dialog.open(DialogDeleteComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Eliminar) {
        this.deleteRowData(result.data);
      }
    });
  }


  openDialogPersona<T>(params: { accion: string, idPersona:  T }) {


      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false

      switch (params.accion) {
        case AccionesDialog.Ver:
          dialogConfig.width = "80%"
          break;

        default:
          dialogConfig.width = "80%"
          break;
      }
      dialogConfig.data = params

      const dialogRef = this.dialog.open(DialogFormPersonaComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if (!result || !result.event) return;

        switch (result.event) {
          case AccionesDialog.Agregar:
            break;
          case AccionesDialog.Modificar:
            break;
          case AccionesDialog.Eliminar:
            break;
          default:

            break;
        }

      });
    }


  deleteRowData(id: number) {
    this.spinner.show('spExpedienteParte')
    this.expedienteParteService.delete(id)
      .subscribe(
        data => {
          this.spinner.hide('spExpedienteParte')
          this.snackBar.showSuccess("Registro dado de baja correctamente.", "Exito");
          this.getExpedienteParteByIdExpediente(this.idExpediente);
        },
        error => {
          this.spinner.hide('spExpedienteParte')
          this.snackBar.showError(error, "Error");
        });
  }
}
